import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-622d0324")

_pushScopeId("data-v-622d0324")
const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { for: "exampleInputEmail1" }
const _hoisted_3 = {
  key: 1,
  class: "card mb-1 customer-details"
}
const _hoisted_4 = { class: "table table-borderless table-sm text-left mb-0" }
const _hoisted_5 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Customer Id", -1)
const _hoisted_6 = { class: "table-list-value" }
const _hoisted_7 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Email", -1)
const _hoisted_8 = { class: "table-list-value" }
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "col-12 px-1" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = /*#__PURE__*/_createVNode("input", {
  type: "submit",
  style: {"display":"none"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_vue_select = _resolveComponent("vue-select")

  return (_openBlock(), _createBlock("form", {
    class: "create-order-customer-filter-form",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.getFilteredUsers && _ctx.getFilteredUsers(...args)), ["prevent"]))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("label", _hoisted_2, _toDisplayString(_ctx.label || 'Customer'), 1),
      (_ctx.users)
        ? (_openBlock(), _createBlock(_component_vue_select, {
            key: 0,
            placeholder: "First name...",
            modelValue: _ctx.selectedCustomer,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedCustomer = $event)),
            "label-by": 
          option =>
            option
              ? option.firstName +
                ' ' +
                option.lastName +
                ' - ' +
                _ctx.hideEmail(option.email)
              : ''
        ,
            "clear-on-close": false,
            options: _ctx.users,
            searchable: "",
            "onSearch:input": _cache[2] || (_cache[2] = _withModifiers(event => _ctx.hanldeSearchInput(event), ["prevent","stop"])),
            "onSearch:focus": _ctx.clear,
            "clear-on-select": "",
            "close-on-select": ""
          }, null, 8, ["modelValue", "label-by", "options", "onSearch:focus"]))
        : _createCommentVNode("", true),
      (_ctx.selectedCustomer)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("table", _hoisted_4, [
              _createVNode("tr", null, [
                _hoisted_5,
                _createVNode("td", _hoisted_6, _toDisplayString(_ctx.selectedCustomer.id), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_7,
                _createVNode("td", _hoisted_8, _toDisplayString(_ctx.hideEmail(_ctx.selectedCustomer.email)), 1)
              ])
            ]),
            (_ctx.$slots['actions'])
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  _hoisted_10
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _renderSlot(_ctx.$slots, "actions")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_13
  ], 32))
})